import { useEffect, useState } from 'react'
import ListCloseIcon from '@pc/components/Works/Panel/shared/List/ListCloseIcon'
import ListItem from '@pc/components/Works/Panel/shared/List/ListItem'
import ListItemDescription from '@pc/components/Works/Panel/shared/List/ListItemDescription'
import ListItemName from '@pc/components/Works/Panel/shared/List/ListItemName'
import ListItemParagraph from '@pc/components/Works/Panel/shared/List/ListItemParagraph'
import ListOpenIcon from '@pc/components/Works/Panel/shared/List/ListOpenIcon'
import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/types'
import OccupationCheckboxes from './OccupationCheckBoxes'
import type { ComponentPropsWithoutRef, MouseEvent } from 'react'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategory: BigCategory
  smallCategories: SmallCategory[]
}

const OccupationListItem = (props: ComponentPropsWithoutRef<'li'>) => <ListItem className="cursor-pointer" {...props} />

const OccupationListItemParagraph = (props: ComponentPropsWithoutRef<'dl'>) => (
  <ListItemParagraph className="relative w-full [&_svg]:absolute [&_svg]:right-4" {...props} />
)

const OccupationListItemName = (props: ComponentPropsWithoutRef<'dt'>) => <ListItemName className="min-w-62 font-bold" {...props} />

const OccupationListDescription = (props: ComponentPropsWithoutRef<'dd'>) => <ListItemDescription className="mr-8" {...props} />

const BigOccupationItem = (props: PropsType) => {
  const { bigCategory, smallCategories, selectedJobIds, changeJobIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const toggleChildren = (e: MouseEvent) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  const joinSmallCategorieNames = smallCategories.map((smallCategory) => smallCategory.attributes.name).join('、')

  useEffect(() => {
    const isSelectedBeforehand = smallCategories.some((smallCategory) => selectedJobIds.includes(smallCategory.attributes.id.toString()))
    if (isSelectedBeforehand) {
      setChildrenIsOpen(true)
    }
  }, [smallCategories, selectedJobIds])

  return (
    <OccupationListItem>
      <OccupationListItemParagraph onClick={toggleChildren}>
        <OccupationListItemName>{bigCategory.attributes.name}</OccupationListItemName>
        <OccupationListDescription>{joinSmallCategorieNames}</OccupationListDescription>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </OccupationListItemParagraph>
      {childrenIsOpen ? (
        <OccupationCheckboxes
          bigCategory={bigCategory}
          smallCategories={smallCategories}
          selectedJobIds={selectedJobIds}
          changeJobIds={changeJobIds}
        />
      ) : null}
    </OccupationListItem>
  )
}

export default BigOccupationItem
